import {type Command, Extension} from '@tiptap/core';
import {MarkType} from "web-ng2/delt/komponenter/skjema/riktekst-redigering/tiptap/TipTapEditor";
import {erTall} from "felles-ng2/støttefunksjoner/tall";
import {dekodTallMedBenevnelse} from "web-ng2/delt/komponenter/skjema/riktekst-redigering/tiptap/tiptapHjelpere";

/** Tiptap utvidelse som legger til attributtet 'fontstørrelse' for bruk på noder som støtter 'textStyle' mark.
 * 'fontstørrelse' er et tall uten benevnelse, men vi bruker 'pt' som standard ved konvertering til css */
export const Fontstørrelse = Extension.create({

    name: 'Fontstørrelse',

    addGlobalAttributes() {
        return [{
            types: tillatteMarktyper(),
            attributes: {
                fontstørrelse: {
                    default: null,
                    renderHTML: attributter => fontstørrelseSomHtmlStyleAttributt(attributter),
                    parseHTML: element => htmlFontSizeStyleSomTekststørrelseAttributt(element),
                    keepOnSplit: true
                }
            }
        }];
    },

    addCommands(): FontstørrelseKommandoer<Command> {
        return {
            setFontstoerrelse: (fontstørrelse: number) => ({chain}) =>
              chain().setMark(MarkType.TextStyle, {fontstørrelse: fontstørrelse}).run(),

            fjernFontstoerrelse: () => ({chain}) =>
              chain()
                .setMark(MarkType.TextStyle, {fontstørrelse: null})
                .removeEmptyTextStyle()
                .run(),
        };
    },
});


function tillatteMarktyper() {
    return [MarkType.TextStyle];
}

/** Serialiserer 'fontstørrelse' attributtet til html css style.font-size attributt */
export function fontstørrelseSomHtmlStyleAttributt(attributter: Record<string, any>): Record<string, any> {
    return erTall(attributter.fontstørrelse) ? {style: `font-size: ${fontstørrelseSomCssVerdi(attributter.fontstørrelse)}`} : {};
}

/** Deserialiserer css style.font-size property satt på angitt element til fontstørrelse */
function htmlFontSizeStyleSomTekststørrelseAttributt(element: HTMLElement): number {
    return dekodTallMedBenevnelse(element.style.fontSize, 'pt', 10);
}

/** Returnere angitt tall som '<tall>pt' */
export function fontstørrelseSomCssVerdi(fontstørrelse: number): string {
    return `${fontstørrelse}pt`;
}


// typedefinisjoner

interface FontstørrelseKommandoer<ReturnType> {

    /** Setter fontstørrelse på tekst */
    setFontstoerrelse: (fontstørrelse: number) => ReturnType;

    /** Fjerner eventuell fontstørrelse på tekst */
    fjernFontstoerrelse: () => ReturnType;
}

//for at kommandoene skal dukke opp i editor ts typen
declare module '@tiptap/core' {
    interface Commands<ReturnType> {
        fontstørrelse: FontstørrelseKommandoer<ReturnType>;
    }
}
